import React from 'react';
import * as HeroIconsSolid from '@heroicons/react/24/solid';
import * as HeroIconsOutline from '@heroicons/react/24/outline';
import { cn } from '@/lib/utils';
import { convertStringToIconName } from '@/utils/heroicons';

export type IconName =
  | keyof typeof HeroIconsSolid
  | keyof typeof HeroIconsOutline;

interface DynamicHeroIconProps {
  iconName: string;
  shape: 'solid' | 'outline';
  className?: string;
  asChild?: boolean;
}

const DynamicHeroIcon: React.FC<DynamicHeroIconProps> = ({
  iconName,
  shape,
  className,
  asChild = false,
}) => {
  const convertedIconName = convertStringToIconName(iconName);
  const IconComponent =
    shape === 'solid'
      ? HeroIconsSolid[convertedIconName]
      : HeroIconsOutline[convertedIconName];

  if (!IconComponent) {
    //return default if icon is invalid
    //TODO: Log error to Sentry
    return <HeroIconsSolid.AcademicCapIcon />;
  }
  if (asChild) {
    return <IconComponent />;
  }
  return (
    <div className={cn(className)}>
      <IconComponent />
    </div>
  );
};

export { DynamicHeroIcon };
